import { render, staticRenderFns } from "./ScbDataTable.vue?vue&type=template&id=3bc6c4e9&scoped=true"
import script from "./ScbDataTable.vue?vue&type=script&lang=js"
export * from "./ScbDataTable.vue?vue&type=script&lang=js"
import style0 from "./ScbDataTable.vue?vue&type=style&index=0&id=3bc6c4e9&prod&scoped=true&lang=css"
import style1 from "./ScbDataTable.vue?vue&type=style&index=1&id=3bc6c4e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6c4e9",
  null
  
)

export default component.exports